import { cn } from '../utils/cn';
import { FURNITURE_ICONS } from './icons';

/** Renders a furniture-type duotone icon (brand teal) for the given key. */
export function FurnitureIcon({ type, className }: { type: string; className?: string }) {
  const render = FURNITURE_ICONS[type] ?? FURNITURE_ICONS.misc!;
  return (
    <svg viewBox="0 0 48 48" className={cn('block', className)} role="img" aria-hidden="true">
      {render()}
    </svg>
  );
}
